// ============================================
// 2026-10-02｜Q3c：3D 场景 ↔ 2D 大屏 关联跨标签页同步
// - 场景编辑器与大屏编辑器可能在不同浏览器标签打开；任一侧关联/解除后，
//   通过 BroadcastChannel 广播，另一侧无需刷新即可同步
// - 同源跨标签共享；不支持 BroadcastChannel 的环境静默降级（各自刷新仍一致）
// ============================================

export interface FusionSyncMessage {
  type: 'page-scene-linked';
  pageId: string;
  /** 关联的场景 id；null=解除关联 */
  sceneId: string | null;
  source: 'scene' | 'dashboard';
}

const CHANNEL = 'dtwin-fusion-sync';

export function broadcastFusion(msg: FusionSyncMessage): void {
  try {
    if (typeof BroadcastChannel === 'undefined') return;
    const ch = new BroadcastChannel(CHANNEL);
    ch.postMessage(msg);
    ch.close();
  } catch {
    /* 忽略（隐私模式等） */
  }
}

export function subscribeFusion(cb: (msg: FusionSyncMessage) => void): () => void {
  try {
    if (typeof BroadcastChannel === 'undefined') return () => {};
    const ch = new BroadcastChannel(CHANNEL);
    ch.onmessage = (e) => {
      const msg = e.data as FusionSyncMessage;
      if (msg?.type === 'page-scene-linked') cb(msg);
    };
    return () => ch.close();
  } catch {
    return () => {};
  }
}
